import { call, put, takeLatest, takeEvery } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchKitLists({ payload }) {
  try {
    const res = yield call(API.fetchAllKits, payload?.data);
    const { data } = res;
    yield put(actions.fetchKitListsSuccess(data));
    payload?.onSuccess();
  } catch (err) {
    yield put(actions.fetchKitListsFailure(err?.response?.data));
    payload?.onFailure(err?.response?.data);
    console.log("error", err?.response);
  }
}

export function* handleFetchStates({ payload }) {
  try {
    const res = yield call(API.fetchAllStates, payload);
    const { data } = res;
    yield put(actions.fetchStatesSuccess(data));
  } catch (err) {
    yield put(actions.fetchStatesFailure(err?.response?.data));
  }
}

export function* handleFetchDistricts({ payload }) {
  try {
    const res = yield call(API.fetchDistrictsForState, payload);
    const { data } = res;
    yield put(actions.fetchDistrictsSuccess({data, For: payload?.For}));
  } catch (err) {
    yield put(actions.fetchDistrictsFailure(err?.response?.data));
  }
}

export function* handleFetchAgency({ payload }) {
  try {
    const res = yield call(API.fetchAllAgencies, payload);
    const { data } = res;
    yield put(actions.fetchAgencySuccess(data));
  } catch (err) {
    yield put(actions.fetchAgencyFailure(err?.response?.data));
  }
}
export function* handleFetchStatus({ payload }) {
  try {
    const res = yield call(API.fetchKitsStatus, payload);
    const { data } = res;
    yield put(actions.fetchStatusSuccess(data));
  } catch (err) {
    yield put(actions.fetchStatusFailure(err?.response?.data));
  }
}

export function* handleFetchSamplers({ payload }) {
  try {
    const res = yield call(API.fetchSamplersForDistrict, payload);
    const { data } = res;
    yield put(actions.fetchSamplersSuccess({data, For: payload?.For}));
  } catch (err) {
    yield put(actions.fetchSamplersFailure(err?.response?.data));
  }
}

export function* handleFetchProjects({ payload }) {
  try {
    const res = yield call(API.fetchAllCompaniesProjectCodes, payload);
    const { data } = res;
    yield put(actions.fetchProjectsSuccess(data));
  } catch (err) {
    yield put(actions.fetchProjectsFailure(err?.response?.data));
  }
}

export function* handleCreateKitSeals({ payload }) {
  try {
    const res = yield call(API.createKitSeals, payload?.postData);
    const { data } = res;
    yield put(actions.createKitSealsSuccess(data));
    payload?.onSuccess();

  } catch (err) {
    console.log("error", err?.response?.data);
    yield put(actions.createKitSealsFailure(err?.response?.data));
    payload?.onFailure(err?.response?.data);
  }
}
export function* handleKitAssignToSampler({ payload }) {
  try {
    const res = yield call(API.kitAssignToSampler, payload?.postData);
    const { data } = res;
    yield put(actions.kitAssignToSamplerSuccess(data));
    payload?.onSuccess();
  } catch (err) {
    yield put(actions.kitAssignToSamplerFailure(err?.response?.data));
    payload?.onFailure(err?.response?.data);
  }
}

export function* handleUpdateKitStatus({ payload }) {
  try {
    const res = yield call(API.updateKitStatus, payload?.postData);
    const { data } = res;
    yield put(actions.updateKitStatusSuccess(data));
    payload?.onSuccess();
  } catch (err) {
    yield put(actions.updateKitStatusFailure(err?.response?.data));
    payload?.onFailure(err?.response?.data);
  }
}

export function* handleGetLogisticList({ payload }) {
  try {
    const res = yield call(API.fetchAllLogisticPartners, payload);
    const { data } = res;
    yield put(actions.getLogisticListSuccess(data));
    payload?.onSuccess();
  } catch (err) {
    yield put(actions.getLogisticListFailure(err?.response?.data));
    payload?.onFailure(err?.response?.data);
  }
}

export function* handleAssignLogisticToKit({ payload }) {
  try {
    const res = yield call(API.assignLogisticToKit, payload?.postData);
    const { data } = res;
    yield put(actions.assignLogisticToKitSuccess());
    payload?.onSuccess();
  } catch (err) {
    yield put(actions.assignLogisticToKitFailure(err?.response?.data));
    payload?.onFailure(err?.response?.data);
  }
}

export function* handleGetSampleSealTypes({ payload }) {
  try {
    const res = yield call(API.getSampleSealType, payload);
    const { data } = res;
    yield put(actions.getSampleSealTypesSuccess(data));
    // payload?.onSuccess();
  } catch (err) {
    yield put(actions.getSampleSealTypesFailure(err?.response?.data));
    // payload?.onFailure(err?.response?.data);
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* assetManagementSaga() {
  yield takeLatest(actions.fetchKitLists.type, handleFetchKitLists);
  yield takeLatest(actions.fetchStates.type, handleFetchStates);
  yield takeLatest(actions.fetchDistricts.type, handleFetchDistricts);
  yield takeLatest(actions.fetchAgency.type, handleFetchAgency);
  yield takeLatest(actions.fetchStatus.type, handleFetchStatus);
  yield takeLatest(actions.fetchSamplers.type, handleFetchSamplers);
  yield takeLatest(actions.fetchProjects.type, handleFetchProjects);
  yield takeEvery(actions.createKitSeals.type, handleCreateKitSeals);
  yield takeEvery(actions.kitAssignToSampler.type, handleKitAssignToSampler);
  yield takeEvery(actions.updateKitStatus.type, handleUpdateKitStatus);
  yield takeLatest(actions.getLogisticList.type, handleGetLogisticList);
  yield takeEvery(actions.assignLogisticToKit.type, handleAssignLogisticToKit);
  yield takeLatest(actions.getSampleSealTypes.type, handleGetSampleSealTypes);

}
